export const ADD_TO_CART_LOADING = "ADD_TO_CART_LOADING";
export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
export const ADD_TO_CART_ERROR = "ADD_TO_CART_ERROR";
export const SET_CART_TOTAL = "SET_CART_TOTAL";
export const SET_SHIPPING_ADDRESS = "SET_SHIPPING_ADDRESS";
export const DELETE_FROM_CART_SUCCESS = "DELETE_FROM_CART_SUCCESS";
